import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { showAlert } from '../../../../lib/functions/utils';

const NarResponse = (props: any) => {
  const dispatch = useDispatch();
  const { response } = props;
  const [validResponse, setValidResponse] = useState(true);
  const [data, setData] = useState<any>(null);

  const verifyResponse = () => {
    const rawData = response?.data;
    const normalizedData = Array.isArray(rawData) ? rawData[0] : rawData;

    if (!normalizedData) {
      showAlert(
        dispatch,
        'error',
        'No se pudieron obtener los datos de la consulta. Intenta más tarde.',
      );
      setValidResponse(false);
      return false;
    }

    setData(normalizedData);
    setValidResponse(true);
    return true;
  };

  useEffect(() => {
    verifyResponse();
  }, [response]);

  return (
    <div>
      {validResponse && data && (
        <Box sx={{ padding: 2 }}>
          <Typography variant="body1" sx={{ marginBottom: 1 }}>
            <strong>Nombre o Razón Social:</strong> {data.name}
          </Typography>
          <Typography variant="body1" sx={{ marginBottom: 1 }}>
            <strong>Rut:</strong> {data.rut}
          </Typography>
          <Typography variant="body1" sx={{ marginBottom: 1 }}>
            <strong>Fecha consulta:</strong> {data.dateTime}
          </Typography>
          <Typography variant="body1" sx={{ marginBottom: 1 }}>
            <strong>Situación:</strong> {data.situationRaw}
          </Typography>
        </Box>
      )}
    </div>
  );
};

export default NarResponse;
